import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetValidateLEsByIds = ({
  ids,
  onSuccess,
}: {
  ids: number[]
  onSuccess: () => void
}) => {
  const post = useTypedApiClient({
    path: '/admin/corporate-accounts/licensed-establishments/validate-le-ids',
    method: 'post',
  })

  return useQuery({
    queryKey: [
      '/admin/corporate-accounts/licensed-establishments/validate-le-ids',
      ids,
    ],
    enabled: ids.length > 0,
    queryFn: async () => {
      const { data } = await post(ids)
      onSuccess()
      return data
    },
  })
}
